import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelM } from '@sorare/core/src/atoms/typography';
import { LeagueAvatar } from '@sorare/core/src/components/league/LeagueAvatar';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

import { Line } from '#src/components/essence/CardPullExperience/CardPullInfos/ui.tsx';

import type { AvailableCompetitions_competition } from './__generated__/index.graphql.ts';

type Props = {
  competitions: AvailableCompetitions_competition[];
};
const Root = styled(Vertical)`
  width: 100%;
  @media ${laptopAndAbove} {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

const StyledLine = styled(Line)`
  width: 100%;
  @media ${laptopAndAbove} {
    width: calc(50% - var(--half-unit));
  }
`;

export const AvailableCompetitions = ({ competitions }: Props) => {
  if (competitions.length === 0) return null;

  return (
    <Root>
      {competitions.map(competition => (
        <StyledLine key={competition.slug}>
          <LeagueAvatar league={competition} size={16} />
          <LabelM>{competition.displayName}</LabelM>
        </StyledLine>
      ))}
    </Root>
  );
};

AvailableCompetitions.fragments = {
  competition: gql`
    fragment AvailableCompetitions_competition on Competition {
      slug
      name
      displayName
    }
  ` as TypedDocumentNode<AvailableCompetitions_competition>,
};
